<template>
    <v-flex xs12>
      <data-source-table
        itemController="geotag"
        itemIdentifyField="name"
        :headers="mainHeaders"
        :options.sync="options"
        :selected-items.sync="selectedItems"
        :get-data-hook="getDataHook"
        :add-item-hook="addItemHook"
        ref="dataSourceRef"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <confirm-dialog
              :is-open.sync="dialogs.geotagMarkers.isOpened"
              dialog-max-width="800px"
              :show-confirm-button="false"
            >
              <template v-slot:activator>
                <v-btn
                  class="mx-2" color="primary"
                  dark fab small
                  @click="openDialog('geotagMarkers')"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <slot>
                        <v-icon v-bind="attrs" v-on="on" dark>
                          mdi-earth
                        </v-icon>
                      </slot>
                    </template>
                    show selected geotags on map
                  </v-tooltip>
                </v-btn>
              </template>
              <template v-slot:title>
              </template>
              <template v-slot:body>
                <div v-if="selectedItems.length>0">
                  <GoogleMapMarkers
                    :items="selectedItems"
                    :isVisible="dialogs.geotagMarkers.isOpened"
                    :maxZoom="5"
                    :make-title="(item) => `${item.id}. ${item.name}`
                    + (item.airports_iata_icao.length
                      ? `\nairports: ${item.airports_iata_icao.map((el) => el[0]).join(', ')}`
                      : '')
                    + (item.sequenceGeotags.length
                      ? `\nsequence: ${item.sequenceGeotags.map((el) => el.name).join(', ')}`
                      : '')"
                    :make-info-window-content="(item) => `<div>${item.id}. ${item.name}</div>`
                    + (item.airports_iata_icao.length
                  ? `<div>airports: ${item.airports_iata_icao.map((el) => el[0]).join(', ')}</div>`
                      : '')
                     + (item.sequenceGeotags.length
                    ?`<div>sequence: ${item.sequenceGeotags.map((el) => el.name).join(', ')}</div>`
                      : '')"
                  />
                </div>
                <div v-else>
                  None of geotags were selected. Please select geotags.
                </div>
              </template>
            </confirm-dialog>

            <confirm-dialog
              v-if="!hasSomeAbilities($constants.ABILITY.SALES_INTERN)"
              :is-open.sync="dialogs.bulkCustomers.isOpened"
              width="400"
              @confirm="setBulkGeotagsCustomer"
              confirm-button-text="add"
            >
              <template v-slot:activator>
                <v-btn
                  class="mx-2" color="cyan darken-3"
                  dark fab small
                  @click="openDialog('bulkCustomers')"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <slot>
                        <v-icon v-bind="attrs" v-on="on" dark>
                          mdi-bank-plus
                        </v-icon>
                      </slot>
                    </template>
                    bulk add customers
                  </v-tooltip>
                </v-btn>
              </template>
              <template v-slot:title>
                Set customer
              </template>
              <template v-slot:body>
                {{ selectedGeotagsIdsList.length }} Geotags
                <DataList
                  :item-model.sync="dialogs.bulkCustomers.data.customers"
                  :type-object="$constants.DATA_LISTS.CUSTOMER_LIST"
                  label="customer"
                  multiple
                  hide-selected
                  clearable
                  dense
                  chips
                  small-chips
                />
              </template>
            </confirm-dialog>

            <confirm-dialog
              :is-open.sync="dialogs.report.isOpened"
              width="400"
              @confirm="getReport"
              confirm-button-text="report"
            >
              <template v-slot:activator>
                <v-btn
                  class="mx-2" color="primary"
                  dark fab small
                  @click="openDialog('report')"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <slot>
                        <v-icon v-bind="attrs" v-on="on" dark>
                          mdi-file-chart
                        </v-icon>
                      </slot>
                    </template>
                    download report
                  </v-tooltip>
                </v-btn>
              </template>
              <template v-slot:title>
                <span class="headline">Report options</span>
              </template>
              <template v-slot:body>
                <v-container>
                  <v-row
                    align="center"
                    justify="space-between"
                  >POI status:
                    <v-switch
                      v-model="dialogs.report.isWithEnabledPois"
                      label="Enabled"
                    />
                    <v-switch
                      v-model="dialogs.report.isWithDisabledPois"
                      label="Disabled"
                    />
                  </v-row>
                  <v-row
                    align="center"
                    justify="space-between"
                  >
                    Priority:
                    <v-switch
                      v-model="dialogs.report.isWithPriority1"
                      label="1"
                    />
                    <v-switch
                      v-model="dialogs.report.isWithPriority2"
                      label="2"
                    />
                    <v-switch
                      v-model="dialogs.report.isWithPriority3"
                      label="3"
                    />
                    <v-switch
                      v-model="dialogs.report.isWithPriority4"
                      label="4"
                    />
                    <v-switch
                      v-model="dialogs.report.isWithPriorityNotSet"
                      label="Not Set"
                    />
                  </v-row>
                </v-container>
              </template>
            </confirm-dialog>

            <confirm-dialog
              v-if="!hasSomeAbilities($constants.ABILITY.SALES_INTERN)"
              :is-open.sync="dialogs.newGeotag.isOpened"
              dialog-max-width="75%"
              @confirm="saveNew"
              :is-disable-confirm-button="!dialogs.newGeotag.data.name"
              confirm-button-text="save"
            >
              <template v-slot:activator>
                <v-btn
                  class="mx-2" color="primary"
                  dark fab small
                  @click="openDialog('newGeotag')"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <slot>
                        <v-icon v-bind="attrs" v-on="on" dark>
                          mdi-plus
                        </v-icon>
                      </slot>
                    </template>
                    create new geotag
                  </v-tooltip>
                </v-btn>
              </template>
              <template v-slot:title>
                <span class="headline">Geotag</span>
              </template>
              <template v-slot:body>
                <v-container>
                  <v-row>
                    <v-col cols="6" sm="6" md="6">
                      <v-text-field
                        v-model="dialogs.newGeotag.data.name"
                        label="Geotag name"
                      />
                    </v-col>
                    <v-col cols="2" sm="2" md="2">
                      <v-text-field
                        v-model="dialogs.newGeotag.data.placenamesId"
                        clearable
                        label="Placenames ID"
                        type="number"
                      />
                    </v-col>
                    <v-col cols="1" sm="1" md="1">
                      <v-btn
                        :disabled="!dialogs.newGeotag.data.placenamesId"
                        :class="checkButtonClass"
                        @click="checkPlacenamesID"
                      >
                        Check
                      </v-btn>
                    </v-col>
                    <v-col cols="3" sm="3" md="3">
                      <div class="text-h4 text-left">
                        {{ dialogs.newGeotag.data.isPlacenamesRequested
                        ? dialogs.newGeotag.data.placenamesName
                        : ''}}
                      </div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <TripleButton
                        :status="dialogs.newGeotag.data.status"
                        :disabled="true"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" sm="12" md="6">
                      <v-text-field
                        v-model="dialogs.newGeotag.data.lat"
                        label="latitude"
                        type="number"
                        single-line
                        :rules="[rules.lat]"
                      />
                    </v-col>
                    <v-col cols="6" sm="12" md="6">
                      <v-text-field
                        v-model="dialogs.newGeotag.data.lon"
                        label="longitude"
                        type="number"
                        single-line
                        :rules="[rules.lon]"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-combobox
                        v-model="dialogs.newGeotag.data.admintags"
                        :items="admintags"
                        item-text="name"
                        item-value="id"
                        label="admin tags"
                        multiple
                        hide-selected
                        clearable
                        dense
                        chips
                        small-chips
                        deletable-chips
                        :menu-props="{ closeOnContentClick: true }"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-combobox
                        v-model="dialogs.newGeotag.data.customers"
                        :items="customers"
                        item-text="name"
                        item-value="id"
                        label="customers"
                        multiple
                        hide-selected
                        clearable
                        dense
                        chips
                        small-chips
                        deletable-chips
                        :menu-props="{ closeOnContentClick: true }"
                      />
                    </v-col>
                  </v-row>
                </v-container>
              </template>
            </confirm-dialog>

            <v-btn
              v-if="!hasSomeAbilities($constants.ABILITY.SALES_INTERN)"
              class="mx-2" color="primary"
              dark fab small
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <slot>
                  <span
                    class="font-weight-bold"
                    v-bind="attrs"
                    v-on="on"
                    @click="runBilkAi"
                  >AI</span>
                  </slot>
                </template>
                Bulk AI
              </v-tooltip>
            </v-btn>

            <confirm-dialog
              :is-open.sync="dialogs.geotagMarkersCluster.isOpened"
              dialog-max-width="800px"
              :show-confirm-button="false"
            >
              <template v-slot:activator>
                <v-btn
                  class="mx-2" color="green"
                  dark fab small
                  @click="openGeotagMarkersCluster()"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <slot>
                        <v-icon v-bind="attrs" v-on="on" dark>
                          mdi-earth
                        </v-icon>
                      </slot>
                    </template>
                    show all geotags on map
                  </v-tooltip>
                </v-btn>
              </template>
              <template v-slot:title>
              </template>
              <template v-slot:body>
                <DataList
                  :item-model.sync="dialogs.geotagMarkersCluster.data.customers"
                  :type-object="$constants.DATA_LISTS.CUSTOMER_LIST"
                  label="customers"
                  clearable
                  multiple
                  dense
                  chips
                  small-chips
                  deletable-chips
                  with-option-none
                  with-option-any
                  with-option-select-all
                  @change="getGeotagsCoordinates"
                />
                <div v-if="dialogs.geotagMarkersCluster.data.allGeotagsCoordinates.length > 0">
                  <GoogleMapMarkers
                    :items="dialogs.geotagMarkersCluster.data.allGeotagsCoordinates"
                    :isVisible="dialogs.geotagMarkers.isOpened"
                    :maxZoom="5"
                    :is-cluster="true"
                  />
                </div>
                <div v-else>
                  Geotag coordinates list is empty.
                </div>
              </template>
            </confirm-dialog>

            <v-spacer />

            <v-btn
                class="mx-2" color="blue darken-1"
                outlined small
                @click="$refs.dataSourceRef ? $refs.dataSourceRef.openDialogSelectColumns() : false"
            >
              Select columns
            </v-btn>
          </v-toolbar>

          <confirm-dialog
            :is-open.sync="dialogs.hashtags.isOpened"
            width="400"
            @confirm="addHashtags"
            confirm-button-text="save"
          >
            <template v-slot:title>
              {{ getDialogData('hashtags', 'geotag.name') }}
              {{ `(ID: ${getDialogData('hashtags', 'geotag.id')})` }}
            </template>
            <template v-slot:body>
              <v-autocomplete
                :item-text="item => `${item.name} (${item.pois_count})`"
                label="hashtags"
                clearable
                dense
                chips
                small-chips
                multiple
                v-model="dialogs.hashtags.data.hashtags"
                :items="dialogs.hashtags.data.hashtagsList"
                :filter="nonDiacriticsSensitiveFilter"
                return-object
                :menu-props="{ closeOnContentClick: true }"
              />
            </template>
          </confirm-dialog>

          <confirm-dialog
            :is-open.sync="dialogs.admintag.isOpened"
            width="400"
            @confirm="addAdmintag"
            confirm-button-text="save"
          >
            <template v-slot:title>
              {{ getDialogData('admintag', 'geotag.name') }}
              {{ `(ID: ${getDialogData('admintag', 'geotag.id')})` }}
            </template>
            <template v-slot:body>
              <v-autocomplete
                item-text="name"
                label="admin tags"
                clearable
                dense
                chips
                small-chips
                v-model="dialogs.admintag.data.admintag"
                :items="admintags"
                :filter="nonDiacriticsSensitiveFilter"
                return-object
              />
            </template>
          </confirm-dialog>

          <confirm-dialog
            :is-open.sync="dialogs.customer.isOpened"
            width="400"
            @confirm="addCustomers"
            confirm-button-text="save"
          >
            <template v-slot:title>
              {{ getDialogData('customer', 'geotag.name') }}
              {{ `(ID: ${getDialogData('customer', 'geotag.id')})` }}
            </template>
            <template v-slot:body>
              <DataList
                :item-model.sync="dialogs.customer.data.customers"
                :type-object="$constants.DATA_LISTS.CUSTOMER_LIST"
                multiple
                hide-selected
                dense
              />
            </template>
          </confirm-dialog>

          <confirm-dialog
            :is-open.sync="dialogs.sequence.isOpened"
            width="400"
            @confirm="addSequencetag"
            confirm-button-text="save"
          >
            <template v-slot:title>
              {{ getDialogData('sequence', 'geotag.name') }}
              {{ `(ID: ${getDialogData('sequence', 'geotag.id')})` }}
            </template>
            <template v-slot:body>
              <GeotagList
                :geotag-model.sync="dialogs.sequence.data.sequencetag"
                label="geotags"
                return-object
              />
            </template>
          </confirm-dialog>

          <confirm-dialog
            :is-open.sync="dialogs.airports.isOpened"
            dialog-max-width="800"
            :is-disable-confirm-button="true"
          >
            <template v-slot:title>
              {{ dialogs.airports.data.title }}
            </template>
            <template v-slot:body>
              Airports:
              <v-data-table
                :headers="dialogs.airports.data.headers"
                :items="dialogs.airports.data.items"
                :footer-props="{ itemsPerPageOptions: [10, 25, 50, -1] }"
                disable-sort
                disable-pagination
                disable-filtering
              />
            </template>
          </confirm-dialog>

          <v-dialog
            v-model="mapdialog.show"
            min-width="600"
            max-width="800"
            scrollable
            :loading="mapdialog.loading"
          >
            <v-card>
              <v-card-title />
              <v-card-text>
                <GoogleMapLoader
                  ref="geotagMap"
                  @setBounds="setBounds"
                  :bounds="mapdialog.bounds"
                />
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="mapDialogCancel"
                >
                  Cancel
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="mapDialogReset"
                >
                  Reset
                </v-btn>
                <v-btn
                  @click="mapDialogFiltered"
                  color="blue darken-1"
                  text
                >
                  Show
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>

        <template v-slot:filter_airports>
          <v-combobox
            ref="airportsautocomplete"
            :value="options.filters ? options.filters.airports : ''"
            @change="(v) => {
              preventToOpenAirportsCombobox(); $set(options.filters, 'airports', v) }"
            :items="['<empty>']"
            label="icao or iata"
            outlined
            dense
            clearable
          />
        </template>

        <template v-slot:filter_sequence>
          <GeotagList
            :geotag-model.sync="options.filters.sequence"
            label="sequence"
            multiple
            dense
            with-option-any
            with-option-none
          />
        </template>

        <template v-slot:filter_customers>
          <DataList
            :item-model.sync="options.filters.customers"
            :type-object="$constants.DATA_LISTS.CUSTOMER_LIST"
            label="customers"
            clearable
            multiple
            dense
            chips
            small-chips
            deletable-chips
            with-option-none
            with-option-any
            with-option-select-all
          />
        </template>

        <template v-slot:filter_customers_is_destination>
          <DataList
            :item-model.sync="options.filters.customers_is_destination"
            :type-object="$constants.DATA_LISTS.CUSTOMER_LIST"
            label="customers"
            clearable
            multiple
            dense
            chips
            small-chips
            deletable-chips
            with-option-none
            with-option-any
            with-option-select-all
          />
        </template>

        <template v-slot:filter_coordinates>
          <v-container>
            <v-row align="center">
              <v-col cols="2">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      size="small"
                      @click="mapClearBounds"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon small color="grey" >
                        mdi-refresh
                      </v-icon>
                    </v-btn>
                  </template>
                  reset coordinates
                </v-tooltip>
              </v-col>
              <v-col>
                (latMin, lonMin) - (latMax, lonMax)
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="2">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      size="small"
                      @click="mapdialog.show=true"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon small color="grey" >
                        mdi-google-maps
                      </v-icon>
                    </v-btn>
                  </template>
                  select bounds
                </v-tooltip>
              </v-col>
              <v-col>
                {{ options.filters.bounds.latMin
                ? `(${parseFloat(options.filters.bounds.latMin).toFixed(3)}, `
                + `${parseFloat(options.filters.bounds.lonMin).toFixed(3)}) -`
                : null }}
                {{ options.filters.bounds.latMax
                ? `(${parseFloat(options.filters.bounds.latMax).toFixed(3)}, `
                + `${parseFloat(options.filters.bounds.lonMax).toFixed(3)}) -`
                : null }}
              </v-col>
            </v-row>
          </v-container>
        </template>

        <template v-slot:item.airports="{ item }">
          <v-btn
            v-if="item.airport_amount > 0"
            class="ma-2"
            fab
            outlined
            @click="showAirportsDialog(item)"
          >
            <v-icon>
              mdi-airplane
            </v-icon>
          </v-btn>
        </template>

        <template v-slot:item.pois_count="{ item }">
          <div><span class="font-italic">total</span>: {{ item.pois_count }}</div>
          <span class="font-italic">enabled</span>:
          <span class=" green--text">{{ item.enabled_count }}</span>
        </template>

        <template v-slot:item.pois_with_images="{ item }">
          <div><span class="font-italic">total</span>: {{ item.pois_with_images }}</div>
          <span class="font-italic">enabled</span>:
          <span class=" green--text">{{ item.enabled_pois_with_images }}</span>
        </template>

        <template v-slot:item.pois_with_reels="{ item }">
          <div><span class="font-italic">total</span>: {{ item.pois_with_reels }}</div>
          <span class="font-italic">enabled</span>:
          <span class=" green--text">{{ item.enabled_pois_with_reels }}</span>
        </template>

        <template v-slot:item.coordinates="{ item }">
          <v-edit-dialog
            @save="updateItem(itemClone, item)"
            @open="itemClone = {...item}"
          >
            <div class="lat">
              {{  `${item.lat || 'empty'}`}}
            </div>
            <div class="lon">
              {{ `${item.lon || 'empty'}`}}
            </div>
            <template v-slot:input>
              <v-text-field
                type="number"
                label="latitude"
                single-line
                counter
                v-model="itemClone.lat"
                :rules="[rules.lat]"
              ></v-text-field>
              <v-text-field
                type="number"
                label="longitude"
                single-line
                counter
                v-model="itemClone.lon"
                :rules="[rules.lon]"
              ></v-text-field>
            </template>
          </v-edit-dialog>
        </template>

        <template v-slot:item.status="{ item }">
          <TripleButton
            :status="item.status"
            :trigger="triggerCheckTripleButton[item.id] ? triggerCheckTripleButton[item.id] : 0"
            @pressed="triplePressed($event, item)"
          />
        </template>

        <template v-slot:item.name="{ item }">
          <div class="d-flex align-center">
            <v-edit-dialog
              @save="updateGeotag('name', itemClone.name, item)"
              @open="itemClone = {...item}"
            >
              {{ item.name }}
              <template v-slot:input>
                <v-text-field
                  v-model="itemClone.name"
                  label="Edit"
                  single-line
                  counter
                />
              </template>
            </v-edit-dialog>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  class="mx-1"
                  small
                  outlined
                  :color="countColor(item.videodata_count)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon left>
                    mdi-video-image
                  </v-icon>
                  <span class="item-count">{{ item.videodata_count }}</span>
                </v-chip>
              </template>
              videos geotag preview
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  class="mx-1"
                  small
                  outlined
                  :color="countColor(item.poi_images_count)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon left>
                    mdi-image-area
                  </v-icon>
                  <span class="item-count">{{ item.poi_images_count }}</span>
                </v-chip>
              </template>
              images geotag preview
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  class="mx-1"
                  small
                  outlined
                  :color="countColor(item.geotag_images_count)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon left>
                    mdi-image-area
                  </v-icon>
                  <span class="item-count">{{ item.geotag_images_count }}</span>
                </v-chip>
              </template>
              images geotag
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  :to="`geotag/${item.id}`" target="_blank"
                  icon
                  small
                >
                  <v-icon color="orange" dense>
                    mdi-pen
                  </v-icon>
                </v-btn>
              </template>
              geotag page
            </v-tooltip>
          </div>

          <translations-bar
            class="mt-2"
            :id="item.id"
            :translations="translations[item.id] ? translations[item.id] : {}"
            :model="$constants.TRANSLATION_MODELS.GEOTAG"
            :title="item.name"
            :editable="false"
          >
          </translations-bar>
        </template>

        <template v-slot:item.ai="{ item }">
            <open-ai-geotag
              :geotag-data="item"
              @updateGeotagData="updateGeotagData"
              :trigger-run="triggerRunOpenAi[item.id] ? triggerRunOpenAi[item.id] : 0">
            </open-ai-geotag>
        </template>

        <template v-slot:item.region="{ item }">
          <v-edit-dialog
            @save="updateGeotag('region', itemClone.region, item)"
            @open="itemClone = {...item}"
          >
            Name: {{ item.region }}
            <template v-slot:input>
              <v-text-field
                v-model="itemClone.region"
                label="Edit"
                single-line
                counter
              />
            </template>
          </v-edit-dialog>

          <v-edit-dialog
            @save="updateGeotag('region_placenames', itemClone.region_placenames, item)"
            @open="itemClone = {...item};"
          >
            P-Name:
            <span v-if="item.region_placenames_id">({{ item.region_placenames_id }})</span>
            {{ item.region_placenames }}
            <template v-slot:input>
              <v-autocomplete
                v-model="itemClone.region_placenames"
                :items="citiesList"
                item-text="Name"
                item-value="ID"
                :loading="isLoadingCities"
                :search-input.sync="searchExistRegion"
                label="Placenames name"
                clearable
                return-object
              >
                <template v-slot:item="{ item }">
                  {{ item.ID }} - {{ item.Name }} - {{ item.country }}
                </template>
              </v-autocomplete>
            </template>
          </v-edit-dialog>

          <translations-bar
            v-if="item.region_placenames_id"
            class="mt-2"
            :id="item.id"
            :translations="translationsRegionPlacenames[item.id]
             ? translationsRegionPlacenames[item.id] : {}"
            :model="$constants.TRANSLATION_MODELS.GEOTAG_REGION_PLACENAMES"
            :title=
              "`${item.region_placenames} (P-ID: ${item.region_placenames_id}) ${item.region}`"
            :trigger-update="item.region_placenames"
            :editable="false"
          >
          </translations-bar>
          <translations-bar
            v-else
            class="mt-2"
            :id="item.id"
            :translations="translationsRegion[item.id] ? translationsRegion[item.id] : {}"
            :model="$constants.TRANSLATION_MODELS.GEOTAG_REGION"
            :title="item.region"
            :trigger-update="item.region"
          >
          </translations-bar>
        </template>

        <template v-slot:item.admintags="{ item }">
          <v-btn
            text
            color="teal accent-4"
            fab
            small
            @click="showAdmintagDialog(item)"
          >
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <slot>
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-label
                  </v-icon>
                </slot>
              </template>
              add admin tag
            </v-tooltip>
          </v-btn>
          <v-chip
            v-for="tag in item.admintags"
            :key="tag.name"
            close
            @click:close="deleteAdmintag(item, tag)"
            class="ma-0"
            dark
            small
          >
            {{ tag.name }}
          </v-chip>
        </template>

        <template v-slot:item.customers="{ item }">
          <div class="chip-height">
            <v-btn
              text
              color="teal accent-4"
              fab
              small
              @click="showCustomersDialog(item)"
            >
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <slot>
                    <v-icon
                      v-bind="attrs"
                      v-on="on"
                    >
                      mdi-label
                    </v-icon>
                  </slot>
                </template>
                add customers
              </v-tooltip>
            </v-btn>
            <v-chip
              v-for="customer in item.customers"
              :key="customer.name"
              close
              @click:close="deleteCustomer(item, customer)"
              class="ma-0"
              dark
              small
            >
              {{ customer.name }}
            </v-chip>
          </div>
        </template>

        <template v-slot:item.customers_is_destination="{ item }">
          <div class="chip-height">
            <v-chip
                v-for="customer in item.customers_is_destination"
                :key="customer.name"
                class="ma-0"
                dark
                small
            >
              {{ customer.name }}
            </v-chip>
          </div>
        </template>

        <template v-slot:item.hashtags="{ item }">
          <v-btn
            text
            color="teal accent-4"
            fab
            small
            @click="showAddHashtagDialog(item)"
          >
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <slot>
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-label
                  </v-icon>
                </slot>
              </template>
              add hashtag
            </v-tooltip>
          </v-btn>
          <v-chip
            v-for="tag in item.hashtags"
            :key="tag.name"
            close
            @click:close="deleteHashtag(item, tag)"
            class="ma-0"
            dark
            small
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div
                  v-bind="attrs"
                  v-on="on">
                  {{ tag.name }} ({{ tag.enabled_pois_one_four }} +
                  {{ tag.disabled_pois_one_four }})
                </div>
              </template>
              enable + disable POIs with priority 1-4
            </v-tooltip>
          </v-chip>
        </template>

        <template v-slot:item.sequence="{ item }">
          <v-btn
            text
            color="teal accent-4"
            fab
            small
            @click="showSequenceDialog(item)"
          >
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <slot>
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-label
                  </v-icon>
                </slot>
              </template>
              add geotag
            </v-tooltip>
          </v-btn>
          <draggable
            v-model="item.sequence"
            @end="updateItem({...item}, item)"
          >
            <v-list-item
              :draggable="true"
              v-for="(tag, index) in item.sequenceGeotags"
              :key="index"
              dense
              outlined
              class="grey darken-3 rounded-pill mb-1 handle"
            >
              <v-list-item-content>
                <v-list-item-title
                  v-text="tag ? tag.name : ''"
                  class="white--text"
                />
              </v-list-item-content>
              <v-list-item-action>
                <v-btn
                  x-small
                  icon
                  color="grey darken-3"
                  @click="deleteSequencetag(item, tag)"
                >
                  <v-icon
                    small
                    class="white rounded-circle"
                  >
                    mdi-close
                  </v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </draggable>
        </template>
      </data-source-table>
    </v-flex>
</template>

<script>
import { mapActions } from 'vuex';
import draggable from 'vuedraggable';
import GoogleMapLoader from '../components/GoogleMapLoader.vue';
import TripleButton from '../components/TripleButton.vue';
import GoogleMapMarkers from '../components/GoogleMapMarkers.vue';
import OpenAiGeotag from '../components/dialogs/OpenAiGeotag.vue';
import TranslationsBar from '../components/Translations/TranslationsBar.vue';
import DataSourceTable from '../components/DataSource/DataTable.vue';
import ConfirmDialog from '../components/dialogs/ConfirmDialog.vue';
import manageDialogsMixin from '../mixins/manageDialogsMixin';
import GeotagList from '../components/DataLists/GeotagList.vue';
import DataList from '../components/DataLists/DataList.vue';

export default {
  name: 'Geotag',
  components: {
    DataList,
    GeotagList,
    ConfirmDialog,
    TranslationsBar,
    OpenAiGeotag,
    GoogleMapLoader,
    draggable,
    TripleButton,
    GoogleMapMarkers,
    DataSourceTable,
  },
  data: () => ({
    rules: {
      lat: (v) => (v > -90 && v < 90) || 'Incorrect value!',
      lon: (v) => (v > -180 && v < 180) || 'Incorrect value!',
    },
    selectedItems: [],
    options: { filters: { bounds: {} } },
    mapdialog: {
      title: '',
      show: false,
      loading: false,
      bounds: {
        latMax: null,
        latMin: null,
        lonMax: null,
        lonMin: null,
      },
    },
    itemClone: {},
    hashtags: [],
    admintags: [],
    customers: [],
    geotagsAirportsCache: {},
    triggerRunOpenAi: {},
    translations: {},
    translationsRegion: {},
    translationsRegionPlacenames: {},
    citiesList: [{ ID: null, Name: 'Set Empty', country: '' }],
    timerSearchRegion: null,
    searchExistRegion: null,
    isLoadingCities: false,
    triggerCheckTripleButton: {},
    dialogs: {
      geotagMarkers: {
        isOpened: false,
        data: {
        },
        defaults: {
        },
      },
      geotagMarkersCluster: {
        isOpened: false,
        data: {
          allGeotagsCoordinates: [],
          customers: null,
        },
        defaults: {
          allGeotagsCoordinates: [],
          customers: null,
        },
      },
      bulkCustomers: {
        isOpened: false,
        data: {
          customers: [],
        },
        defaults: {
          customers: [],
        },
      },
      report: {
        isOpened: false,
        data: {
          isWithEnabledPois: true,
          isWithDisabledPois: true,
          isWithPriority1: true,
          isWithPriority2: true,
          isWithPriority3: true,
          isWithPriority4: true,
          isWithPriorityNotSet: true,
        },
        defaults: {
          isWithEnabledPois: true,
          isWithDisabledPois: true,
          isWithPriority1: true,
          isWithPriority2: true,
          isWithPriority3: true,
          isWithPriority4: true,
          isWithPriorityNotSet: true,
        },
      },
      newGeotag: {
        isOpened: false,
        data: {
          placenamesName: '',
          isPlacenamesMatched: false,
          isPlacenamesRequested: false,
          name: '',
          status: 0,
          lat: null,
          lon: null,
          admintags: null,
          customers: null,
          placenamesId: null,
        },
        defaults: {
          placenamesName: '',
          isPlacenamesMatched: false,
          isPlacenamesRequested: false,
          name: '',
          status: 0,
          lat: null,
          lon: null,
          admintags: null,
          customers: null,
          placenamesId: null,
        },
      },
      hashtags: {
        isOpened: false,
        data: {
          geotag: {},
          hashtags: [],
          hashtagsList: [],
        },
        defaults: {
          geotag: {},
          hashtags: [],
          hashtagsList: [],
        },
      },
      admintag: {
        isOpened: false,
        data: {
          geotag: {},
          admintag: null,
        },
        defaults: {
          geotag: {},
          admintag: null,
        },
      },
      customer: {
        isOpened: false,
        data: {
          geotag: {},
          customers: [],
        },
        defaults: {
          geotag: {},
          customers: [],
        },
      },
      sequence: {
        isOpened: false,
        data: {
          geotag: {},
          sequencetag: null,
        },
        defaults: {
          geotag: {},
          sequencetag: null,
        },
      },
      airports: {
        isOpened: false,
        data: {
          title: '',
          headers: [
            { text: 'id', value: 'airportID', sortable: false },
            { text: 'iata', value: 'iata', sortable: false },
            { text: 'icao', value: 'icao', sortable: false },
            { text: 'name', value: 'name', sortable: false },
          ],
          items: [],
        },
        defaults: {
          title: '',
          headers: [
            { text: 'id', value: 'airportID', sortable: false },
            { text: 'iata', value: 'iata', sortable: false },
            { text: 'icao', value: 'icao', sortable: false },
            { text: 'name', value: 'name', sortable: false },
          ],
          items: [],
        },
      },
    },
  }),

  mixins: [
    manageDialogsMixin,
  ],

  created() {
    this.$requestHelpers.get('api/admin/hashtag')
      .then((response) => {
        this.hashtags = response.data;
      });

    this.$requestHelpers.get('api/admin/poitag')
      .then((response) => {
        this.admintags = response.data;
      });
  },

  mounted() {
  },

  methods: {
    ...mapActions({
      setSnack: 'snackbar/setState',
    }),
    getDataHook() {
      this.getTranslations();
      this.getTranslationsRegion();
      this.getTranslationsRegionPlacenames();
    },
    addItemHook() {
    },

    getTranslations(ids = []) {
      this.$requestHelpers.post(
        'api/admin/bulk-translations',
        {
          model: this.$constants.TRANSLATION_MODELS.GEOTAG,
          ids: ids.length === 0 ? this.$refs.dataSourceRef.allItems().map((item) => item.id) : ids,
        },
      ).then((response) => {
        if (ids.length === 0) {
          this.translations = response.data.result;
        } else {
          this.translations = {
            ...this.translations,
            ...response.data.result,
          };
        }
      });
    },

    getTranslationsRegion(ids = []) {
      this.$requestHelpers.post(
        'api/admin/bulk-translations',
        {
          model: this.$constants.TRANSLATION_MODELS.GEOTAG_REGION,
          ids: ids.length === 0 ? this.$refs.dataSourceRef.allItems().map((item) => item.id) : ids,
        },
      ).then((response) => {
        if (ids.length === 0) {
          this.translationsRegion = response.data.result;
        } else {
          this.translationsRegion = {
            ...this.translationsRegion,
            ...response.data.result,
          };
        }
      });
    },

    getTranslationsRegionPlacenames(ids = []) {
      this.$requestHelpers.post(
        'api/admin/bulk-translations',
        {
          model: this.$constants.TRANSLATION_MODELS.GEOTAG_REGION_PLACENAMES,
          ids: ids.length === 0 ? this.$refs.dataSourceRef.allItems().map((item) => item.id) : ids,
        },
      ).then((response) => {
        if (ids.length === 0) {
          this.translationsRegionPlacenames = response.data.result;
        } else {
          this.translationsRegionPlacenames = {
            ...this.translationsRegionPlacenames,
            ...response.data.result,
          };
        }
      });
    },

    saveNew() {
      return this.$refs.dataSourceRef.saveNew(this.dialogs.newGeotag.data)
        .finally(() => this.closeDialog('newGeotag'));
    },

    updateItem(itemClone, item) {
      return this.$refs.dataSourceRef.updateItem(itemClone, item);
    },

    updateGeotag(field, value, item) {
      return this.$refs.dataSourceRef.updateItemField(field, value, item);
    },

    updateGeotagData(data) {
      this.$refs.dataSourceRef.updateData(data);
    },

    runBilkAi() {
      this.selectedGeotagsIdsList.forEach((id) => {
        this.$set(
          this.triggerRunOpenAi,
          id,
          this.triggerRunOpenAi[id] ? this.triggerRunOpenAi[id] += 1 : 1,
        );
      });
    },

    deleteHashtag(geotag, hashtag) {
      this.updateGeotag('remove_hashtag', hashtag, geotag);
    },

    deleteSequencetag(geotag, sequencetag) {
      this.updateGeotag('remove_sequencetag', sequencetag, geotag);
    },

    deleteAdmintag(geotag, tag) {
      this.updateGeotag('remove_admintag', tag, geotag);
    },

    deleteCustomer(geotag, customer) {
      this.updateGeotag('remove_customer', customer, geotag);
    },

    showSequenceDialog(item) {
      this.openDialog(
        'sequence',
        { geotag: item },
      );
    },
    addSequencetag() {
      if (!this.dialogs.sequence.data.sequencetag) return;

      this.updateGeotag(
        'add_sequencetag', this.dialogs.sequence.data.sequencetag, this.dialogs.sequence.data.geotag,
      ).finally(() => this.closeDialog('sequence'));
    },

    showAddHashtagDialog(item) {
      this.$requestHelpers.post('api/admin/hashtags/getSequenceGeotagPoisHashtags',
        {
          geotag_id: item.id,
        }).then((response) => {
        this.openDialog(
          'hashtags',
          { geotag: item, hashtagsList: response.data },
        );
      });
    },
    addHashtags() {
      if (!this.dialogs.hashtags.data.hashtags) return;

      this.updateGeotag(
        'add_hashtags', this.dialogs.hashtags.data.hashtags, this.dialogs.hashtags.data.geotag,
      ).finally(() => this.closeDialog('hashtags'));
    },

    showAdmintagDialog(item) {
      this.openDialog(
        'admintag',
        { geotag: item },
      );
    },
    addAdmintag() {
      if (!this.dialogs.admintag.data.admintag) return;

      this.updateGeotag(
        'add_admintag', this.dialogs.admintag.data.admintag, this.dialogs.admintag.data.geotag,
      ).finally(() => this.closeDialog('admintag'));
    },

    showCustomersDialog(item) {
      this.openDialog(
        'customer',
        { geotag: item },
      );
    },
    addCustomers() {
      if (!this.dialogs.customer.data.customers) return;

      this.updateGeotag(
        'add_customers', this.dialogs.customer.data.customers, this.dialogs.customer.data.geotag,
      ).finally(() => this.closeDialog('customer'));
    },

    getReport() {
      this.$requestHelpers
        .post('api/admin/report/report',
          {
            bit_mask: this.bitMask,
          },
          {
            responseType: 'blob',
          })
        .then((response) => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const fileLink = document.createElement('a');
          const headerval = response.headers['content-disposition'];
          const filename = headerval.match(/filename="(.*)"/);

          fileLink.href = fileURL;
          fileLink.setAttribute('download', filename[1]);
          document.body.appendChild(fileLink);

          fileLink.click();
        }).finally(() => {
          this.closeDialog('report');
        });
    },

    mapDialogCancel() {
      this.mapdialog.show = false;
    },
    mapDialogReset() {
      if (this.$refs.geotagMap) {
        this.$refs.geotagMap.clearBounds();
      }
    },
    mapClearBounds() {
      if (this.$refs.geotagMap) {
        this.$refs.geotagMap.clearBounds();
      }
      this.$set(this.mapdialog, 'bounds', { ...{} });
      this.$set(this.options.filters, 'bounds', { ...{} });
    },
    mapDialogFiltered() {
      this.mapdialog.show = false;
      this.$set(this.options.filters, 'bounds', { ...this.mapdialog.bounds });
    },
    setBounds(bounds) {
      Object.assign(this.mapdialog.bounds, bounds);
    },

    triplePressed(status, item) {
      this.updateItem({ ...item, status }, item)
        .finally(() => {
          this.$set(
            this.triggerCheckTripleButton,
            item.id,
            this.triggerCheckTripleButton[item.id]
              ? this.triggerCheckTripleButton[item.id] += 1 : 1,
          );
        });
    },

    countColor(count) {
      if (count > 0) return '#388E3C';
      return '#BDBDBD';
    },

    setBulkGeotagsCustomer() {
      if (!this.selectedItems.length || !this.dialogs.bulkCustomers.data.customers) {
        this.closeDialog('bulkCustomers');
        return false;
      }

      this.updateBulk(
        this.selectedItems.map((item) => item.id),
        { add_customers: this.dialogs.bulkCustomers.data.customers },
      ).finally(() => {
        this.closeDialog('bulkCustomers');
      });

      return true;
    },

    updateBulk(geotagsIds, geotagFields) {
      return this.$refs.dataSourceRef.updateBulk(geotagsIds, geotagFields);
    },

    async showAirportsDialog(item) {
      if (!this.geotagsAirportsCache[item.id]) {
        await this.$requestHelpers.post('api/admin/placenames/airports',
          {
            id: item.placenames_id,
          }).then((response) => {
          this.geotagsAirportsCache[item.id] = {
            airports: response.data,
            is_checked: true,
          };
        });
      }

      this.openDialog(
        'airports',
        {
          items: this.geotagsAirportsCache[item.id].airports,
          title: `${item.airport_name} (${item.country})`,
        },
      );
    },

    preventToOpenAirportsCombobox() {
      this.$nextTick(() => {
        this.$refs.airportsautocomplete.isMenuActive = false;
      });
    },

    checkPlacenamesID() {
      this.dialogs.newGeotag.data.isPlacenamesMatched = false;

      this.$requestHelpers
        .post('api/admin/placenames/extendedData', {
          placenames: [this.dialogs.newGeotag.data.placenamesId],
          extended_columns: ['Name', 'en', 'Lat', 'Lon'],
        })
        .then((response) => {
          if (response.data[this.dialogs.newGeotag.data.placenamesId]) {
            const placenames = response.data[this.dialogs.newGeotag.data.placenamesId];
            this.dialogs.newGeotag.data.isPlacenamesMatched = true;
            this.dialogs.newGeotag.data.placenamesName = placenames.Name;
            this.dialogs.newGeotag.data.name = placenames.en;
            this.dialogs.newGeotag.data.lat = placenames.Lat;
            this.dialogs.newGeotag.data.lon = placenames.Lon;
          } else {
            this.dialogs.newGeotag.data.placenamesName = '<not found>';
            this.dialogs.newGeotag.data.lat = null;
            this.dialogs.newGeotag.data.lon = null;
            this.dialogs.newGeotag.data.name = '';
          }
        }).finally(() => {
          this.dialogs.newGeotag.data.isPlacenamesRequested = true;
        });
    },

    searchRegion(value, lat, lon, item) {
      // search if length more than 3 chars
      if (!value || value.length < 3) return;

      // Items have already been requested
      if (this.isLoadingCities) return;

      // skip if select value
      if (value === (item?.Name)) return;

      // cancel pending call
      clearTimeout(this.timerSearchRegion);

      // delay new call 2000ms
      this.timerSearchRegion = setTimeout(() => {
        this.isLoadingCities = true;

        this.$requestHelpers.post(
          'api/admin/placenames/search',
          {
            name: value,
            category: 'all',
          },
        ).then((response) => {
          this.citiesList = [...[{ ID: null, Name: 'Set Empty', country: '' }], ...response.data];
        }).finally(() => { this.isLoadingCities = false; });
      }, 1000);
    },

    openGeotagMarkersCluster() {
      if (this.dialogs.geotagMarkersCluster.data.allGeotagsCoordinates.length === 0) {
        this.$requestHelpers
          .post('api/admin/geotag/geotagsCoordinatesList')
          .then((response) => {
            this.openDialog('geotagMarkersCluster', {
              allGeotagsCoordinates: response.data.result,
            });
          });
      } else {
        this.openDialog('geotagMarkersCluster', this.dialogs.geotagMarkersCluster.data);
      }
    },
    getGeotagsCoordinates() {
      this.$requestHelpers
        .post('api/admin/geotag/geotagsCoordinatesList', {
          customers: this.getDialogData('geotagMarkersCluster', 'customers'),
        })
        .then((response) => {
          this.dialogs.geotagMarkersCluster.data.allGeotagsCoordinates = response.data.result;
        });
    },
  },

  watch: {
    // eslint-disable-next-line func-names
    'dialogs.newGeotag.data.placenamesId': function () {
      this.dialogs.newGeotag.data.isPlacenamesRequested = false;
    },
    searchExistRegion(value) {
      this.searchRegion(
        value,
        this.itemClone.lat,
        this.itemClone.lon,
        this.itemClone.region_placenames,
      );
    },
  },

  computed: {
    headers() {
      return [
        {
          text: 'id', value: 'id', width: '120px', isRequired: true,
        },
        {
          text: 'name', value: 'name', width: '310px',
        },
        {
          text: 'AI',
          value: 'ai',
          width: '130px',
          sortable: false,
          filter: { type: 'select', items: ['with', 'without'] },
        },
        {
          text: 'country', value: 'country', width: '200px', sortable: false,
        },
        {
          text: 'state', value: 'state', width: '200px', sortable: false,
        },
        {
          text: 'airports', value: 'airports', width: '120px', sortable: false,
        },
        {
          text: 'shortcut', value: 'shortcut', width: '200px', isDefault: false, edit: { type: 'text', emptyPlaceholder: true },
        },
        {
          text: 'region', value: 'region', width: '200px',
        },
        {
          text: 'sequence', value: 'sequence', width: '200px', sortable: false,
        },
        {
          text: 'poi count', value: 'pois_count', width: '100px',
        },
        {
          text: 'poi reels', value: 'pois_with_reels', width: '100px',
        },
        {
          text: 'poi images', value: 'pois_with_images', width: '100px',
        },
        {
          text: 'coordinates', value: 'coordinates', width: '200px', sortable: false, isDefault: false,
        },
        {
          text: 'tripexpert id',
          value: 'tripexpert_id',
          width: '100px',
          sortable: false,
          isDefault: false,
          edit: { type: 'number', emptyPlaceholder: true },
        },
        {
          text: 'tags',
          value: 'hashtags',
          width: '300px',
          sortable: false,
          filter: { type: 'multipleSelect', items: this.hashtags },
        },
        {
          text: 'customers',
          value: 'customers',
          width: '200px',
          sortable: false,
        },
        {
          text: 'is_destination',
          value: 'is_destination',
          width: '80px',
          filter: { type: 'select', items: ['on', 'off'] },
          edit: { type: 'switch' },
        },
        {
          text: 'destination for customers',
          value: 'customers_is_destination',
          width: '200px',
          sortable: false,
        },
        {
          text: 'status',
          value: 'status',
          width: '180px',
          filter: { type: 'select', items: ['off', 'prev', 'prev only', 'live'] },
        },
        {
          text: 'native status',
          value: 'native_status',
          width: '80px',
          edit: { type: 'switch' },
          filter: { type: 'select', items: [{ id: 1, name: 'on' }, { id: 0, name: 'off' }] },
        },
        {
          text: 'admin tags',
          value: 'admintags',
          width: '200px',
          sortable: false,
          filter: { type: 'multipleSelect', items: this.admintags },
        },
        {
          text: '', value: 'deleteItem', width: '80px', sortable: false,
        },
      ];
    },

    bitMask() {
      let val = 0;
      val += this.dialogs.report.isWithEnabledPois ? 1 : 0;
      val += this.dialogs.report.isWithDisabledPois ? 2 : 0;
      val += this.dialogs.report.isWithPriority1 ? 4 : 0;
      val += this.dialogs.report.isWithPriority2 ? 8 : 0;
      val += this.dialogs.report.isWithPriority3 ? 16 : 0;
      val += this.dialogs.report.isWithPriority4 ? 32 : 0;
      val += this.dialogs.report.isWithPriorityNotSet ? 64 : 0;
      return val;
    },

    selectedGeotagsIdsList() {
      return this.selectedItems.map(
        (item) => item.id,
      );
    },

    checkButtonClass() {
      if (!this.dialogs.newGeotag.data.isPlacenamesRequested) {
        return '';
      }

      if (this.dialogs.newGeotag.data.isPlacenamesMatched) {
        return 'success';
      }

      return 'error';
    },

    mainHeaders() {
      return this.headers;
    },
  },
};
</script>

<style lang="css" scoped>
.handle {
  cursor: move;
}
.chip-height {
  max-height: 200px;
  overflow: auto;
  margin: 10px 0;
}
</style>
